import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import RecordPagination from '../../utils/RecordsPagination';

import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    negativeColor: {
        color: "red"
    },
    positiveColor: {
        color: "green"
    }
};

const CustomTableCell = withStyles(theme => ({
    head: {
        color: " #66bb6a",
        fontSize: "14px",
        fontWeight: "lighter"
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

const OutstandingSettlementsTableStructure = ({ classes, outstandingSettlementsData, pageIndex }) => (

    <div
        className={classes.tableResponsive}
        style={{ overflowX: "auto" }}
    >
        <Table className={classes.table} aria-labelledby="tableTitle">
            <TableHead color="success">
                <TableRow>
                    <CustomTableCell >
                       S/N
          </CustomTableCell>
                    <CustomTableCell >
                        Airline<br />Name
          </CustomTableCell>
                    <CustomTableCell >
                        Flight<br />No
          </CustomTableCell>
                    <CustomTableCell >
                        Departure<br />Airport
          </CustomTableCell>
                    <CustomTableCell >
                        Departure<br />Date
          </CustomTableCell>
                    <CustomTableCell >
                        Total<br />Passengers
          </CustomTableCell>
                    <CustomTableCell >
                        Billable<br />Passengers
          </CustomTableCell>
                    <CustomTableCell >
                        Outstanding<br />Billable<br />Passengers
          </CustomTableCell>
                    {/* <CustomTableCell >
                        Settlement<br />Date
          </CustomTableCell> */}
                    <CustomTableCell >
                        PSC<br />Payment
          </CustomTableCell>
                    {/* <CustomTableCell >
                        Wallet<br />Balance
          </CustomTableCell> */}
                    <CustomTableCell >Status</CustomTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {outstandingSettlementsData.map((n, i) => {
                    return (
                        <TableRow
                            hover
                            // onClick={event => this.handleClick(event, n.id)}
                            // tabIndex={-1}
                            key={i}
                        >
                            <CustomTableCell component="th" >
                               {pageIndex + i}
                            </CustomTableCell>
                            <CustomTableCell component="th" >
                                {n.AirlineName}
                            </CustomTableCell>
                            <CustomTableCell component="th" >
                                {n.FlightNumber}
                            </CustomTableCell>
                            <CustomTableCell >
                                {n.DepartureAirportName}
                            </CustomTableCell>
                            <CustomTableCell >
                            {(n.DepartureDate) ? appHelpers.formatDate(n.DepartureDate) : ""}
                            </CustomTableCell>
                            <CustomTableCell >
                                {n.PassengerCount}
                            </CustomTableCell>
                            <CustomTableCell >
                                {n.BillablePassengerCount}
                            </CustomTableCell>
                            <CustomTableCell >
                                {n.OutstandingBillablePassengerCount}
                            </CustomTableCell>
                            {/* <CustomTableCell >
                                {(n.SettlementDate) ? appHelpers.formatDate(n.SettlementDate) : ""}
                            </CustomTableCell> */}
                            <CustomTableCell >
                                &#8358; {appHelpers.numberWithCommas(n.PscPayment)}
                            </CustomTableCell>
                            {/* <CustomTableCell >
                                &#8358; {appHelpers.numberWithCommasOnly(n.WalletBalance)}
                            </CustomTableCell> */}
                            <CustomTableCell >
                                {n.Status === "Successful" ? (
                                    <span className={classes.positiveColor}>
                                        {n.Status}
                                    </span>
                                ) : (
                                        <span className={classes.negativeColor}>
                                            {n.Status}
                                        </span>
                                    )}
                            </CustomTableCell>
                        </TableRow>
                    );
                })}
                {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 48 * emptyRows }}>
                        <CustomTableCell colSpan={6} />
                    </TableRow>
                )} */}
            </TableBody>
            {/* <TableFooter>
                <TableRow>
                    <TablePagination
                        colSpan={3}
                        count={data.Results.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        className={classes.pagination}
                    // ActionsComponent={TablePaginationActionsWrapped}
                    />
                </TableRow>
            </TableFooter> */}
        </Table>
    </div>
)

class OutstandingSettlementsTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        const { classes, outstandingSettlementsData, fetchOutstandingSettlements, totalCount, pageSize, currentPage } = this.props
        const pageIndex = (pageSize * (currentPage - 1)) + 1;

        return (
            <div>
                <RecordPagination
                    fetchMore={fetchOutstandingSettlements}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    target={<OutstandingSettlementsTableStructure
                        classes={classes} pageIndex={pageIndex}
                        outstandingSettlementsData={outstandingSettlementsData} />} />
            </div>
        )
    }
}

export default withStyles(styles)(OutstandingSettlementsTable);



// WEBPACK FOOTER //
// ./src/views/OutstandingSettlement/OutstandingSettlementsTable.jsx